import { inject, Injectable } from '@angular/core';
import { Language } from '@core/models/language';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private _translate = inject(TranslateService);
    private _language?: Language;

    // encapsulate the translate lang change event in a behavior subject to be sure to retrieve the right information at each subscription
    private _langChange = new BehaviorSubject<LangChangeEvent | null>(null);

    constructor() {
        this._translate.onLangChange
            .pipe(
                tap((e: LangChangeEvent) => {
                    this._language = e.lang as Language;
                    document.documentElement.lang = e.lang;
                }),
            )
            .subscribe(this._langChange);
    }

    public get language(): Language {
        return this._language || (this._translate.currentLang as Language);
    }

    /**
     * Use this event instead of translate.onLangChange
     */
    get onLangChange(): Observable<LangChangeEvent> {
        return this._langChange.pipe(filter((e): e is LangChangeEvent => e != null));
    }

    get translate(): TranslateService {
        return this._translate;
    }
}
